﻿window.plannedscheduleimport = function () {
    var instance = {
        init: function (state) {

        },
        widgetDidMount: function (state) {

            const element = document.getElementById(state.root);


            element.addEventListener('paste', function (e) {
                setReadOnly(e,element);
            });       

        }
    };
    
    function setReadOnly(e,element){

        let paste = (e.clipboardData || window.clipboardData).getData('text');

        element.innerHTML = paste;
        element.value = paste;
        element.readOnly = true;
    }

    return instance;
}();